import sha256sum from "@js/helpers/sha256.js";
import { putJSON } from "@js/helpers/communication.js";

export const CE_BACKGROUND_SAVE_STARTED = "CE_BACKGROUND_SAVE_STARTED";
export const CE_BACKGROUND_SAVE_FAILURE = "CE_BACKGROUND_SAVE_FAILURE";
export const CE_BACKGROUND_SAVE_SUCCESS = "CE_BACKGROUND_SAVE_SUCCESS";
export const CE_BACKGROUND_SAVE_ABORTED = "CE_BACKGROUND_SAVE_ABORTED";
export const CE_BACKGROUND_SAVE_ERROR_BANNER_SHOW =
  "CE_BACKGROUND_SAVE_ERROR_BANNER_SHOW";
export const CE_BACKGROUND_SAVE_ERROR_BANNER_HIDE =
  "CE_BACKGROUND_SAVE_ERROR_BANNER_HIDE";

const contentUploadData = (content) => {
  let data = {
    id: content.id,
    client_content_id: content.client_content_id,
    name: content.name,
    format: content.format,
    subject: content.subject,
    active_html_editor: content.active_html_editor,
    verification_sha256: {},
  };

  let setWithVerification = (field) => {
    let value = content[field] || "";
    let checksum = sha256sum(value);

    if (content.published_sha256[field] === checksum) {
      data.verification_sha256[field] = checksum;
    } else {
      data[field] = value;
    }
  };

  setWithVerification("bee_json");
  setWithVerification("html");
  setWithVerification("text");

  return data;
};

const attachmentUploadData = (attachment) => {
  if (attachment.id) {
    // Existing attachment

    return {
      id: attachment.id,
      client_attachment_id: attachment.client_attachment_id,
      sha256: attachment.sha256,
    };
  } else {
    // New attachment

    return {
      client_attachment_id: attachment.client_attachment_id,
      attachment_name: attachment.attachment_name,
      sha256: attachment.sha256,
      data_base64: attachment.data_base64,
    };
  }
};

export const ceBackgroundSaveShowErrorBanner = () => ({
  type: CE_BACKGROUND_SAVE_ERROR_BANNER_SHOW,
});

export const ceBackgroundSaveHideErrorBanner = () => ({
  type: CE_BACKGROUND_SAVE_ERROR_BANNER_HIDE,
});

export const ceBackgroundSave = () => (dispatch, getState) => {
  dispatch({ type: CE_BACKGROUND_SAVE_STARTED });

  let state = getState();
  let dataGenerationID = state.sync.data_generation_id;
  let url = Routes.api_v2_campaign_update_path(state.campaign_id);

  let payload = {
    campaign: {
      contents: state.data.contents.map(contentUploadData),
      attachments: state.data.attachments.map(attachmentUploadData),
    },
  };
  putJSON(url, payload, (data, err) => {
    if (err || !data) {
      // Network (or other non-validation) error. These will be retried.
      dispatch({
        type: CE_BACKGROUND_SAVE_FAILURE,
        error: err,
        data_generation_id: dataGenerationID,
      });
      return;
    }
    // We successfully received a response from the server. The reducer will
    // process it.
    dispatch({
      type: CE_BACKGROUND_SAVE_SUCCESS,
      response: data,
      data_generation_id: dataGenerationID,
    });
  });
};
